module.exports = __webpack_public_path__ + "img/172.6132f092.jpg";